import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import AddDoctorScheduleForm from "./AddDoctorScheduleForm";
import DoctorScheduleCalendar from "./DoctorScheduleCalendar";
import SuccessMessage from "../../Components/shared/SuccessMessage";
import BulkBlockModal from "./BulkBlockModal";
import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import PageHeader from "../../Components/PageHeader";

function DoctorSchedulePage() {
  const { doctorId } = useParams();
  const [doctor, setDoctor] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);

  const [successMessage, setSuccessMessage] = useState("");
  const [isError, setIsError] = useState(false);

  // ✅ Refresh trigger to re-fetch calendar data
  const [refreshTrigger, setRefreshTrigger] = useState(Date.now());

  useEffect(() => {
    const fetchDoctor = async () => {
      try {
        const doctorRes = await axiosInstance.get(
          `/doctors/details/${doctorId}`
        );
        setDoctor(doctorRes.data);
      } catch (error) {
        console.error("Failed to load doctor details:", error);
        setSuccessMessage("Failed to load doctor details.");
        setIsError(true);
      }
    };

    fetchDoctor();
  }, [doctorId]);

  const handleScheduleAdded = () => {
    setRefreshTrigger(Date.now());
    // setSuccessMessage("✅ Schedule added successfully!");
    setIsError(false);
    setShowForm(false);
  };

  return (
    <div className="w-full px-1 sm:px-4 lg:px-8 py-2 sm:py-4">
      {successMessage && (
        <SuccessMessage
          message={successMessage}
          isError={isError}
          onClose={() => setSuccessMessage("")}
        />
      )}

      {/* Page Header */}
      <PageHeader
        title={`Schedule for ${doctor?.name || "Doctor"}`}
        subtitle={`Manage schedules and availability for ${
          doctor?.name || "this doctor"
        }`}
        showBackButton={true}
      />

      {showForm ? (
        <div className="mb-4 sm:mb-6">
          <AddDoctorScheduleForm
            doctorId={doctorId}
            setShowForm={setShowForm}
            setSuccessMessage={setSuccessMessage}
            setIsError={setIsError}
            onScheduleAdded={handleScheduleAdded}
          />
        </div>
      ) : (
        <div className="flex gap-3 mb-4 sm:mb-6 mx-2 sm:mx-0 flex-wrap">
          <button
            onClick={() => setShowForm(true)}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm sm:text-base"
          >
            Add New Schedule
          </button>
          <button
            onClick={() => setShowBlockModal(true)}
            className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded text-sm sm:text-base"
          >
            <CalendarDaysIcon className="w-5 h-5" />
            Block Schedule
          </button>
        </div>
      )}

      <DoctorScheduleCalendar
        doctorId={doctorId}
        refreshTrigger={refreshTrigger}
      />

      {/* Unified Block Schedule Modal */}
      <BulkBlockModal
        isOpen={showBlockModal}
        onClose={() => setShowBlockModal(false)}
        doctorId={doctorId}
        doctorName={doctor?.name || "Doctor"}
        onSuccess={(message) => {
          setSuccessMessage(message);
          setIsError(false);
          setRefreshTrigger(Date.now());
          setTimeout(() => setSuccessMessage(""), 3000);
        }}
      />
    </div>
  );
}

export default DoctorSchedulePage;
